import { ConnectedRouter }       from 'connected-react-router/immutable';
import * as React                from 'react';
import { Provider }              from 'react-redux';
import Switch                    from 'react-router-dom/Switch';
import styled, { ThemeProvider } from 'styled-components';
import tinycolor                 from 'tinycolor2';
import './App.css';
import ErrorBoundary             from './components/generic/ErrorBoundry';
import DocumentSeo               from './components/page_elements/DocumentSeo';
import { DocumentTitle }         from './components/page_elements/DocumentTitle';
import CookieNotAllowedModal     from './components/profile/cookies/CookieNotAllowedModal';
import CookiesDialog             from './components/profile/cookies/CookiesDialog';
import { LoggedInUserPreLoader } from './components/resources/User/LoggedInUserPreLoader';
import routes                    from './config/routes';
import FontSizeAdjuster          from './modules/accessibility/components/FontSizeAdjuster';
import EditToggle                from './modules/editableContent/components/EditToggle';
import history                   from './router/history';
import { storePropType }         from './store';
import theme2018                 from './theme/themes/theme2018';

const StyleProvider = styled('div')`
  height: 100%;
  color: ${props => props.theme.colors.primary};

  *::selection {
    ${props => props.theme.textRules.subtleHighlight};
  }

  a:focus,
  span:focus,
  input:focus,
  select:focus,
  textarea:focus,
  button:focus,
  a:active {
    outline: none;
    outline: 0 !important;
    -webkit-box-shadow: 0 0 0 0.2rem
      ${props =>
  tinycolor(props.theme.colors.subtleHighlight)
    .setAlpha(0.5)
    .toRgbString()} !important;
    box-shadow: 0 0 0 0.2rem
      ${props =>
  tinycolor(props.theme.colors.subtleHighlight)
    .setAlpha(0.5)
    .toRgbString()} !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Overlock',cursive;
    margin-top: 0;
    color: ${props => props.theme.colors.primary};
  }

  h1,
  .h1 {
    font-size: 2.3rem;
  }
`;


class App extends React.Component {

  render() {

    return (
      <ErrorBoundary>
        <ThemeProvider theme={theme2018}>
          <Provider store={this.props.store}>
            <FontSizeAdjuster>
              <StyleProvider>
                <LoggedInUserPreLoader>
                  <DocumentTitle>
                    <DocumentSeo keywords="" description="">
                      <ConnectedRouter history={history}>
                        <div className="App">
                          <EditToggle className="rounded-bottom"/>
                          <CookiesDialog/>
                          <Switch>{routes.getSites().map(route => route.routeComponent)}</Switch>
                          <CookieNotAllowedModal/>
                        </div>
                      </ConnectedRouter>
                    </DocumentSeo>
                  </DocumentTitle>
                </LoggedInUserPreLoader>
              </StyleProvider>
            </FontSizeAdjuster>
          </Provider>
        </ThemeProvider>
      </ErrorBoundary>
    );

  }

}

App.propTypes = {
  // Store to use
  store: storePropType.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js